import e from"../createLucideIcon.js";const o=e("ChevronUp",[["polyline",{points:"18 15 12 9 6 15",key:"1uugdp"}]]);export{o as default};
